<template>
    <div v-if="settings">
        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">ApiKey</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.apiKey" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">SharedKey</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.sharedKey" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.apiUrl" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Thumbnail Url Format</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.thumbnailUrlFormat" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">CertBase64</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <textarea v-model="settings.certBase64" class="textarea"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="saveSettingsAsync();" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import betconstructService from "../../../../services/betconstruct.service";

    export default {
        name: "client-settings-betconstruct",
        data: () => ({ settings: null }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        async mounted() {
            this.loadSettingsAsync();
        },
        methods: {
            async loadSettingsAsync() {
                this.settings = await betconstructService.getSettingsAsync(this.clientId);
            },
            async saveSettingsAsync() {
                return await betconstructService.saveSettingsAsync(this.clientId, this.settings);
            }
        }
    };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/betconstruct.vue